<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6">
        <b-form @submit.stop.prevent="handleSubmit">
          <b-card>
            <div slot="header">
              <strong>Delete Invoice Data</strong>
            </div>
            <b-row>
              <b-col sm="12">
                <form-group :validator="$v.form.period"
                            label="Period"
                            :use-horizontal="false">
                  <b-form-input type="month"
                                placeholder="Enter period"
                                autocomplete="off"
                                v-model="form.period"></b-form-input>
                </form-group>
              </b-col>
              <!--applicable to accounts-->
              <!--<b-col sm="12">
                <form-group :validator="$v.form.accounts"
                            label="Choose Accounts"
                            :use-horizontal="false">
                  <treeselect v-model="form.accounts"
                              placeholder="Select Accounts"
                              :multiple="true"
                              :options="options.account" />
                </form-group>
              </b-col>-->
            </b-row>
            <div slot="footer">
              <b-button @click="$router.go(-1)" size="sm"> Back </b-button>
              <b-button type="submit"
                        size="sm"
                        variant="success"
                        class="float-right">
                Delete All
              </b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";

  export default {
    data: () => ({
      form: {
        period: null,
        accounts: [],
      },
      options: {
        account: [],
      }
    }),
    validations: {
      form: {
        period: { required },
      },
    },
    created() {
      //this.getAccounts();
    },
    methods: {
      handleSubmit() {
        const self = this;

        self.$v.form.$touch();
        if (self.$v.form.$pending || self.$v.form.$error) return;

        let _confirmText =
          "You are about to delete the invoices. This will delete all the associated payments as well. Are you sure ?",
          _okText = "Yes, Delete",
          _action = "apis/post",
          _url = "/transaction/invoice/delete-all";

        self.$dialog
          .confirm(_confirmText, {
            okText: _okText,
            cancelText: "Cancel",
            loader: true,
          })
          .then((dialog) => {
            self.$store
              .dispatch(_action, {
                url: _url,
                params: self.form,
              })
              .then((response) => {
                dialog.close();
                if (response.error) {
                  self.$message.error({
                    zIndex: 10000,
                    message: response.message,
                  });
                } else {
                  self.$message.success({
                    zIndex: 10000,
                    message: response.message,
                  });

                  self.$router.go(-1);
                }
              });
          });
      },
      getAccounts() {
        const self = this;
        self.$store
          .dispatch("apis/get", {
            url: "/account",
          })
          .then((response) => {
            if (response.error) {
              self.$message.error({
                zIndex: 10000,
                message: response.message,
              });
            } else {
              self.options.account = [
                {
                  id: "all",
                  label: "Select All",
                  children: response.data.data.map((x) => ({
                    id: x.accountId,
                    label: `${x.accountId}# ${x.name}`,
                  })),
                },
              ];
            }
          });
      },
    },
  };
</script>
